import { RiLoader5Line } from "react-icons/ri";

const Loader = () => {
    return (
        <p className="pt-12"><RiLoader5Line className="animate-spin text-4xl m-auto" /></p>
    )
}

export default Loader;